<template>
  <div id="classification">
    <div class="top">
      <div class="title">详细信息\ PA600-RQDEx CF1.560.031</div>
    </div>
    <div class="mian-card">
      <div class="left">
        <div class="card-box">
          <div class="left_1">
            <div class="card-top">
              <div class="card-title">固化进度</div>
            </div>
            <div class="progress-box">
              <div
                class="progress"
                v-for="item in progressData"
                :key="item.name"
              >
                <div style="color: rgb(128, 128, 128)">{{ item.name }}</div>
                <div style="width: 50%">
                  <el-progress
                    :percentage="item.percentage ? item.percentage : 0"
                  ></el-progress>
                </div>
              </div>
            </div>

            <div class="table-bottom">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="12"
                layout="total, prev, pager, next, jumper"
                :total="tableDataTotal"
              >
              </el-pagination>
            </div>
          </div>
          <div class="left_2">
            <div class="card-top">
              <div class="card-title">加工图进度</div>
            </div>
            <div class="progress-box">
              <div
                class="progress"
                v-for="item in progressData"
                :key="item.name"
              >
                <div style="color: rgb(128, 128, 128)">{{ item.name }}</div>
                <div style="width: 50%">
                  <el-progress
                    :percentage="item.percentage ? item.percentage : 0"
                  ></el-progress>
                </div>
              </div>
            </div>
            <div class="table-bottom">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="12"
                layout="total, prev, pager, next, jumper"
                :total="tableDataTotal"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="card-box">
          <div class="right_1">
            <div class="card-title">装配图进度</div>
            <div class="progress-box">
              <div
                class="progress"
                v-for="item in progressData"
                :key="item.name"
              >
                <div style="color: rgb(128, 128, 128)">{{ item.name }}</div>
                <div style="width: 50%">
                  <el-progress
                    :percentage="item.percentage ? item.percentage : 0"
                  ></el-progress>
                </div>
              </div>
            </div>

            <div class="table-bottom">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200]"
                :page-size="5"
                pager-count="5"
                layout="total, prev, pager, next, jumper"
                :total="tableDataTotal"
              >
              </el-pagination>
            </div>
          </div>
          <div class="right_2">
            <div class="card-title">装配进度</div>
            <div class="progress-box">
              <div
                class="progress"
                v-for="item in progressData"
                :key="item.name"
              >
                <div style="color: rgb(128, 128, 128)">{{ item.name }}</div>
                <div style="width: 50%">
                  <el-progress :percentage="item.percentage ? item.percentage : 0"></el-progress>
                </div>
              </div>
            </div>

            <div class="table-bottom">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200]"
                :page-size="5"
                pager-count="5"
                layout="total, prev, pager, next, jumper"
                :total="tableDataTotal"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'classification',
  data() {
    return {
      currentPage: 1,
      tableDataTotal: 400,
      progressData: [
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 20
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 50
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 70
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 65
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 15
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 88
        },
        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 72
        },

        {
          name: 'PS7300-AH&A22-9-2653LX-1-1/3(1)',
          percentage: 72
        }
      ]
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    changeRange(data) {
      this.currentDateRange = data;
    }
  }
};
</script>

<style scoped lang="scss">
#classification {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  .left {
    width: 50%;
    height: 100%;
  }
  .right {
    width: 50%;
    height: 100%;
  }
}
.top {
  // height: 7%;
  height: 70px;
  width: 100%;
  // background-color: rgb(145, 113, 71);
  .title {
    position: relative;
    // left: 5%;
    left: 80px;
    // width: 20%;
    width: 450px;
    height: 97%;
    font-size: 1.5rem;
    color: rgba(37, 100, 207, 0.8);
    border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
    display: flex;
    align-items: center;
  }
}
.right {
  .top {
    // height: 7%;
    height: 70px;
    width: 100%;
    // background-color: rgb(145, 113, 71);
    .title {
      position: relative;
      // left: 5%;
      left: 80px;
      // width: 20%;
      width: 280px;
      height: 97%;
      font-size: 1.5rem;
      color: rgba(37, 100, 207, 0.8);
      border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
      display: flex;
      align-items: center;
    }
  }
}
.card-box {
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 24px;
  .left_1 {
    position: relative;
    width: 95%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 36px;
  }
  .left_2 {
    position: relative;
    width: 95%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 36px;
  }
  .right_1 {
    position: relative;
    width: 95%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
  .right_2 {
    position: relative;
    width: 95%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
}
.card-top {
  display: flex;
  align-items: center;
}
.card-title {
  position: relative;
  color: rgb(128, 128, 128);
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  margin: 20px;
  width: 60%;
}
.card-tool {
  position: relative;
  color: rgba(37, 100, 207, 0.8);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  text-decoration-line: underline;
  cursor: pointer;
}
.card_info {
  position: relative;
  height: 65%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -ms-flex-pack: distribute;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: space-around;
  padding-left: 20px;
}
.card_info_lable {
  width: 45%;
  color: #616161;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  span {
    color: #888888;
  }
}
.mian-card {
  display: flex;
  height: 100%;
}
.progress {
  display: flex;
  justify-content: space-around;
  width: 90%;
  align-items: center;
  padding: 0px 0px 10px 0px;
}
.card-table {
  padding: 0 20px 0 20px;
}
.table-bottom {
  position: absolute;
  bottom: 20px;
  left: 20%;
}
.progress-box {
  height: 60%;
  overflow-y: auto;
}
</style>
